import {useState} from "react";
import GatePassService from "../services/api";
import {useSnackbar} from "notistack";
import useGatePassStore from "../zustand/useGatePassStore";
import {useNavigate} from "react-router-dom";

const useGatePass = () => {
    const {enqueueSnackbar} = useSnackbar();
     const navigate = useNavigate();

    const {setGatePassCreated, setGatePassStatusUpdated, setVehicleAddedToBooking, setOrgVehicleAddedToBooking} = useGatePassStore();

    const [isFetchingGatePassList, setFetchingGatePassList] = useState(false);
    const [gatePassListData, setGatePassListData] = useState([]);
    const [isGeneratingSingleGatePass, setGeneratingGatePass] = useState(false);
    const [generatedGatePassData, setGeneratedGatePassData] = useState(null);
    const [isFetchingGatePassDetails, setFetchingGatePassDetails] = useState(false);
    const [gatePassDetailsData, setGatePassDetailsData] = useState(null);
    const [isUpdatingGatePassStatus, setUpdatingGatePassStatus] = useState(false);
    const [isGeneratingBookingGatePass, setGeneratingBookingGatePass] = useState(false);
    const [isListingVehicleBooking, setListingVehicleBooking] = useState(false);
    const [vehicleListBooking, setVehicleListBooking] = useState([]);
    const [isGeneratingVehicleGatePass, setIsGeneratingVehicleGatePass] = useState(false);
    const [generatedVehicleGatePassData, setGeneratedVehicleGatePassData] = useState(null);
    const [isUpdatingGatePass, setUpdatingGatePass] = useState(false);
    const [isFilteringGatePass, setFilteringGatePass] = useState(false);
    const [isFetchingPassType, setFetchingPassType] = useState(false);
    const [passTypeList, setPassTypeList] = useState([]);
    const [isFetchingEntryType, setFetchingEntryType] = useState(false);
    const [entryTypeList, setEntryTypeList] = useState([]);

    const [orgGatePassListData, setOrgGatePassListData] = useState([]);
    const [orgVehicleListBooking, setOrgVehicleListBooking] = useState([]);
    const [isFilteringOrgGatePass, setFilteringOrgGatePass] = useState(false);
    const [isFetchingGatePassAccessLogs, setFetchingGatePassAccessLogs] = useState(false);
    const [gatePassVehicleAccessLogs, setGatePassVehicleAccessLogs] = useState([]);
    const [orgGatePassVehicleAccessLogs, setOrgGatePassVehicleAccessLogs] = useState([]);


    const listGatePass = (parameters) => {
        setFetchingGatePassList(true);
        setGatePassCreated(false);
        setGatePassStatusUpdated(false);

        GatePassService.listGatePass(parameters).then((res) => {
            console.log("listGatePass data xxxx", res);

            if (res.data.success) {
                setFetchingGatePassList(false);
                setGatePassListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching gatePass list:", error);
            const errorMessage = error?.response?.data?.error_message || error.message;

            setGatePassListData([]);
            setFetchingGatePassList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const viewGatePass = (parameters) => {
        setFetchingGatePassDetails(true);

        GatePassService.viewGatePass(parameters).then((res) => {
            console.log("viewGatePass data xxxx", res);

            if (res.data.success) {
                setFetchingGatePassDetails(false);
                setGatePassDetailsData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching gatePass details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassDetailsData([]);
            setFetchingGatePassDetails(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const generateSingleGatePass = (payload, setOpen) => {
        setGeneratingGatePass(true);

        GatePassService.generateSingleGatePass(payload).then((res) => {
            console.log("generateSingleGatePass data xxxx", res);

            if (res.data.success) {
                setGeneratingGatePass(false);
                setGatePassCreated(true);
                setGeneratedGatePassData(res.data.data);

                enqueueSnackbar("Successfully generated gate pass", {
                    variant: "success",
                    autoHideDuration: 3500
                })
                setOpen(false);
            }  

        }).catch((error) => {
            console.error("Error generating single pass:", error);
            console.log("generateSingleGatePass error xxxx", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGeneratingGatePass(false);
            setGeneratedGatePassData(null);
            setGatePassCreated(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })   
    }

    const updateGatePassStatus = (parameters, setOpen) => {
        setUpdatingGatePassStatus(true);

        GatePassService.updateGatePassStatus(parameters).then((res) => {
            console.log("updateGatePassStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingGatePassStatus(false);
                setGatePassStatusUpdated(true);

                enqueueSnackbar("Successfully updated gate pass status", {
                    variant: "success",
                    autoHideDuration: 3500
                })
                setOpen(false);
            } 

        }).catch((error) => {
            console.error("Error updating gate pass status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingGatePassStatus(false);
            setGatePassStatusUpdated(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const generateBookingGatePass = (payload, setOpen) => {
        setGeneratingBookingGatePass(true);

        GatePassService.generateBookingGatePass(payload).then((res) => {
            console.log("generateBookingGatePass data xxxx", res);

            if (res.data.success) {
                setGeneratingBookingGatePass(false);
                enqueueSnackbar("Successfully added vehicle to booking", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                setVehicleAddedToBooking(true);
                setOpen(false);
            }  

        }).catch((error) => {
            console.error("Error generating booking gate pass:", error);
            console.log("generateBookingGatePass error xxxx", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleAddedToBooking(false);
            setGeneratingBookingGatePass(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })   
    }

    const getListVehicleBooking = (parameters) => {
        setListingVehicleBooking(true);
        setVehicleAddedToBooking(false);

        GatePassService.getListVehicleBooking(parameters).then((res) => {
            console.log("getListVehicleBooking data xxxx", res);

            if (res.data.success) {
                setListingVehicleBooking(false);
                setVehicleListBooking(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching vehicle list by booking:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleListBooking([]);
            setListingVehicleBooking(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const generateVehicleGatePass = (payload) => {

        setIsGeneratingVehicleGatePass(true)
        GatePassService.generateVehicleGatePass(payload).then((res) => {
            console.log("generateVehicleGatePass data xxxx", res);

            if (res.data.success) {
                setIsGeneratingVehicleGatePass(false)
                setGeneratedVehicleGatePassData(res.data.data);
                enqueueSnackbar("Successfully generated vehicle gate pass", {
                    variant: "success",
                    autoHideDuration: 3500
                })
            }  

        }).catch((error) => {
            console.error("Error generating vehicle gate pass:", error);
            console.log("generateVehicleGatePass error xxxx", error);
            const errorMessage = error?.response?.data?.error || error.message;
            setIsGeneratingVehicleGatePass(false)
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })   
    }

    const updateGatePass = (parameters, payload) => {
        setUpdatingGatePass(true);

        GatePassService.updateGatePass(parameters, payload).then((res) => {
            console.log("updateGatePass data xxxx", res);

            if (res.data.success) {
                setUpdatingGatePass(false);
                enqueueSnackbar("Successfully updated gate pass", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                navigate(`/gatepass/view?id=${res.data.data.gatepass_uid}`);
            } 

        }).catch((error) => {
            console.error("Error updating gate pass:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingGatePass(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterGatePass = (parameters) => {
        setFilteringGatePass(true);

        GatePassService.filterGatePass(parameters).then((res) => {
            console.log("filterGatePass data xxxx", res);

            if (res.data.success) {
                setFilteringGatePass(false);
                setGatePassListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error filtering gatepass list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassListData(null);
            setFilteringGatePass(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getGatePassPassType = () => {
        setFetchingPassType(true);

        GatePassService.getGatePassPassType().then((res) => {
            console.log("getGatePassPassType data xxxx", res);

            if (res.data.success) {
                setFetchingPassType(false);
                setPassTypeList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching gatepass pass type:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setPassTypeList(null);
            setFetchingPassType(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getGatePassEntryType = () => {
        setFetchingEntryType(true);

        GatePassService.getGatePassEntryType().then((res) => {
            console.log("getGatePassEntryType data xxxx", res);

            if (res.data.success) {
                setFetchingEntryType(false);
                setEntryTypeList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching gatepass entry type:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setEntryTypeList(null);
            setFetchingEntryType(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const listOrgGatePass = (parameters) => {
        setFetchingGatePassList(true);
        // setGatePassCreated(false);
        // setGatePassStatusUpdated(false);

        GatePassService.listOrgGatePass(parameters).then((res) => {
            console.log("listOrgGatePass data xxxx", res);

            if (res.data.success) {
                setFetchingGatePassList(false);
                setOrgGatePassListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching organization gatePass list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setOrgGatePassListData([]);
            setFetchingGatePassList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const generateOrgBookingGatePass = (payload, setOpen) => {
        setGeneratingBookingGatePass(true);

        GatePassService.generateOrgBookingGatePass(payload).then((res) => {
            console.log("generateOrgBookingGatePass data xxxx", res);

            if (res.data.success) {
                setGeneratingBookingGatePass(false);
                enqueueSnackbar("Successfully added vehicle to booking", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                setOrgVehicleAddedToBooking(true);
                setOpen(false);
            }  

        }).catch((error) => {
            console.error("Error generating organization booking gate pass:", error);
            console.log("generateOrgBookingGatePass error xxxx", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setOrgVehicleAddedToBooking(false);
            setGeneratingBookingGatePass(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })   
    }

    const getListOrgVehicleBooking = (parameters) => {
        setListingVehicleBooking(true);
        setOrgVehicleAddedToBooking(false);

        GatePassService.getListOrgVehicleBooking(parameters).then((res) => {
            console.log("getListOrgVehicleBooking data xxxx", res);

            if (res.data.success) {
                setListingVehicleBooking(false);
                setOrgVehicleListBooking(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching organization vehicle list by booking:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setOrgVehicleListBooking([]);
            setListingVehicleBooking(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterOrgGatePass = (parameters) => {
        setFilteringOrgGatePass(true);

        GatePassService.filterOrgGatePass(parameters).then((res) => {
            console.log("filterGatePass data xxxx", res);

            if (res.data.success) {
                setFilteringOrgGatePass(false);
                setOrgGatePassListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error filtering gatepass list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setOrgGatePassListData(null);
            setFilteringOrgGatePass(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getGatePassVehicleAccessLogs = (parameters) => {
        setFetchingGatePassAccessLogs(true);

        GatePassService.getGatePassVehicleAccessLogs(parameters).then((res) => {
            console.log("getGatePassVehicleAccessLogs data xxxx", res);

            if (res.data.success) {
                setFetchingGatePassAccessLogs(false);
                setGatePassVehicleAccessLogs(res.data.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching gatepass vehicle access logs:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassVehicleAccessLogs([]);
            setFetchingGatePassAccessLogs(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getOrgGatePassVehicleAccessLogs = (parameters) => {
        setFetchingGatePassAccessLogs(true);

        GatePassService.getOrgGatePassVehicleAccessLogs(parameters).then((res) => {
            console.log("getOrgGatePassVehicleAccessLogs data xxxx", res);

            if (res.data.success) {
                setFetchingGatePassAccessLogs(false);
                setOrgGatePassVehicleAccessLogs(res.data.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching organization gatepass vehicle access logs:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setOrgGatePassVehicleAccessLogs([]);
            setFetchingGatePassAccessLogs(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateOrgGatePassStatus = (parameters, setOpen) => {
        setUpdatingGatePassStatus(true);

        GatePassService.updateOrgGatePassStatus(parameters).then((res) => {
            console.log("updateOrgGatePassStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingGatePassStatus(false);
                setGatePassStatusUpdated(true);

                enqueueSnackbar("Successfully updated organizationgate pass status", {
                    variant: "success",
                    autoHideDuration: 3500
                })
                setOpen(false);
            } 

        }).catch((error) => {
            console.error("Error updating organization gate pass status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingGatePassStatus(false);
            setGatePassStatusUpdated(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    

    return {
        isFetchingGatePassList,
        gatePassListData,
        listGatePass,

        isGeneratingSingleGatePass,
        generatedGatePassData,
        generateSingleGatePass,

        isFetchingGatePassDetails,
        gatePassDetailsData,
        viewGatePass,

        isUpdatingGatePassStatus,
        updateGatePassStatus,

        isGeneratingBookingGatePass,
        generateBookingGatePass,

        isListingVehicleBooking,
        vehicleListBooking,
        getListVehicleBooking,

        generateVehicleGatePass,

        isUpdatingGatePass,
        updateGatePass,

        isFilteringGatePass,
        filterGatePass,

        isFetchingPassType,
        passTypeList,
        getGatePassPassType,

        isFetchingEntryType,
        entryTypeList,
        getGatePassEntryType,

        listOrgGatePass,
        orgGatePassListData,

        generateOrgBookingGatePass,

        getListOrgVehicleBooking,
        orgVehicleListBooking,
        
        filterOrgGatePass,
        isFilteringOrgGatePass,

        isFetchingGatePassAccessLogs,
        getGatePassVehicleAccessLogs,
        gatePassVehicleAccessLogs,

        getOrgGatePassVehicleAccessLogs,
        orgGatePassVehicleAccessLogs,

        updateOrgGatePassStatus
    }
}

export default useGatePass